export default function SocialProof() {
  const reviews = [
    {
      name: 'Sarah Mitchell — Carmel, IN',
      username: 'sarahmitchell',
      avatar: 'SM',
      rating: 5,
      text: 'Benjamin compared 9 carriers and found us a $750,000 20-year term policy for $41/month. We were paying $103/month through our bank. That\'s $744 back in our pocket every year. Took less than a week start to finish.'
    },
    {
      name: 'James Rodriguez — Fishers, IN',
      username: 'jrodriguez',
      avatar: 'JR',
      rating: 5,
      text: 'I had no idea how underinsured my family was until the free needs analysis. Benjamin walked me through exactly how much income replacement my wife and kids would need. Got $1M in term coverage for $58/month through Mutual of Omaha. Worth every penny.'
    },
    {
      name: 'Emily Thompson — Indianapolis, IN',
      username: 'emilyt',
      avatar: 'ET',
      rating: 5,
      text: 'I\'d been putting off life insurance for years because I thought it would be complicated and expensive. Benjamin had me quoted and approved in 4 days. $500K of coverage for $26/month. No medical exam required. Wish I\'d called sooner.'
    },
    {
      name: 'Michael Chen — Noblesville, IN',
      username: 'mchen',
      avatar: 'MC',
      rating: 5,
      text: 'We came in thinking we just wanted term life. Benjamin explained how an IUL could build real cash value for our kids\' college while also covering us permanently. We now have a strategy — not just a policy. Best financial conversation we\'ve ever had.'
    },
    {
      name: 'Jennifer Williams — Greenwood, IN',
      username: 'jwilliams',
      avatar: 'JW',
      rating: 5,
      text: 'My husband passed unexpectedly two years after we set up our policy through Hoosier Life. The claim process was handled completely for me — I never had to chase anyone. The death benefit paid off our mortgage in full. I cannot say enough.'
    },
    {
      name: 'David Patterson — Westfield, IN',
      username: 'dpatterson',
      avatar: 'DP',
      rating: 5,
      text: 'Self-employed, so I\'d been told I was "hard to insure." Benjamin found two carriers willing to cover me at standard rates — no extra premiums for being a 1099 contractor. $500K for $33/month. Didn\'t think that was possible.'
    }
  ];

  const colors = ['#D97642', '#1A3A52', '#4A5568', '#8B7355', '#6B8E9F', '#A67C52'];

  return (
    <section className="py-16 md:py-[100px] bg-[#0F2A3F] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#D97642]/8 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-white/3 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-[28px] sm:text-[34px] md:text-[40px] font-bold text-white mb-6">
            Real Results from Real Indianapolis &amp; Central Indiana Families
          </h2>
          <div className="flex items-center justify-center gap-2 mb-3">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="ri-star-fill text-[24px] md:text-[28px] text-[#D97642]"></i>
            ))}
          </div>
          <p className="text-[17px] md:text-[18px] font-medium text-white">4.9 out of 5</p>
          <div className="flex items-center justify-center gap-2 mt-2">
            <p className="text-[14px] md:text-[15px] text-white/60">Based on 127 Google Reviews</p>
            <img
              src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png"
              alt="Google Reviews"
              width={74}
              height={24}
              className="h-4 opacity-80"
              loading="lazy"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white/8 backdrop-blur-sm rounded-[20px] md:rounded-[24px] p-6 md:p-8 border border-white/10 hover:bg-white/12 hover:border-[#D97642]/40 transition-all duration-300"
            >
              <div className="flex items-start gap-3 md:gap-4 mb-4 md:mb-5">
                <div
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center text-white text-[16px] md:text-[18px] font-bold flex-shrink-0"
                  style={{ backgroundColor: colors[index % colors.length] }}
                >
                  {review.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-[16px] md:text-[17px] font-bold text-white truncate">
                    {review.name}
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-white/65">@{review.username}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4 md:mb-5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[16px] md:text-[18px] text-[#D97642]"></i>
                ))}
              </div>

              <div className="relative">
                <i className="ri-double-quotes-l text-[28px] md:text-[32px] text-[#D97642] opacity-40 absolute -top-2 -left-2"></i>
                <p className="text-[14px] md:text-[15px] text-white/85 leading-[1.65] pl-5 md:pl-6">
                  {review.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Carrier Trust Strip */}
        <div className="mt-12 pt-10 border-t border-white/10">
          <p className="text-center text-xs font-semibold tracking-widest text-white/55 uppercase mb-6">Comparing rates from 20+ top-rated carriers</p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              'Mutual of Omaha', 'Prudential', 'Nationwide', 'Transamerica', 'AIG',
              'Protective Life', 'North American', 'Lincoln Financial', 'Banner Life', 'Pacific Life',
              'Foresters Financial', 'Principal Life',
            ].map((carrier) => (
              <span
                key={carrier}
                className="px-4 py-2 bg-white/8 border border-white/15 rounded-full text-sm font-medium text-white/70 hover:bg-white/14 hover:border-[#D97642]/40 hover:text-white/90 transition-all"
              >
                {carrier}
              </span>
            ))}
          </div>
          <p className="text-center text-xs text-white/40 mt-4">All carriers hold A or A+ AM Best financial strength ratings</p>
        </div>
      </div>
    </section>
  );
}